module.exports = __webpack_public_path__ + "img/amaan.2a23a6c1.jpg";